import React from 'react';
import {ReactComponent as LogoSvg} from '../../../../assets/icons/commons/logo-innopolis-unione.svg';
import styles from '../../Header.module.css';

export const Logo = () => (
  <div className={styles.logo}>
      <LogoSvg />
  </div>
);

